/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Week_LeadInputs */

const en_coaches_page_week_lead = /** @type {(inputs: Coaches_Page_Week_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A whole week of free hours.`)
};

const pl_coaches_page_week_lead = /** @type {(inputs: Coaches_Page_Week_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cały tydzień wolnych godzin.`)
};

/**
* | output |
* | --- |
* | "A whole week of free hours." |
*
* @param {Coaches_Page_Week_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_week_lead = /** @type {((inputs?: Coaches_Page_Week_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Week_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_week_lead(inputs)
	return en_coaches_page_week_lead(inputs)
});